// extracted by mini-css-extract-plugin
export var colorSquare = "_s7-0";
export var danger = "_s7-5";
export var lightPink = "_s7-8";
export var neutralBlue = "_s7-7";
export var neutralYellow = "_s7-6";
export var normal = "_s7-1";
export var primary = "_s7-2";
export var primaryLight = "_s7-3";
export var solidBlack = "_s7-g";
export var solidGreen = "_s7-b";
export var solidLightBlue = "_s7-d";
export var solidNavy = "_s7-c";
export var solidOrange = "_s7-f";
export var solidPink = "_s7-e";
export var solidRed = "_s7-9";
export var solidYellow = "_s7-a";
export var success = "_s7-4";